import { render, staticRenderFns } from "./EventSlot.vue?vue&type=template&id=2ac1bada&"
import script from "./EventSlot.vue?vue&type=script&lang=js&"
export * from "./EventSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports